import { useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SharedRespLinksBlock } from '../../shared/SharedRespLinksBlock/SharedRespLinksBlock';
import { SharedMobileLinksBlock } from '../../shared/SharedMobileLinksBlock/SharedMobileLinksBlock';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

function BuySharedMoreWaysToBrowseComponent({
    viewer,
    itemSearch,
    internalBuyLinks,
    popularSearchTermClassName,
}) {
    const { isMobile } = useContext(ServerVarsContext);

    return isMobile ? (
        <SharedMobileLinksBlock
            item={null}
            viewer={viewer}
            itemSearch={itemSearch}
            links={internalBuyLinks}
            borderTop
            popularSearchTermClassName={popularSearchTermClassName}
        />
    ) : (
        <SharedRespLinksBlock
            item={null}
            viewer={viewer}
            itemSearch={itemSearch}
            links={internalBuyLinks}
            popularSearchTermClassName={popularSearchTermClassName}
        />
    );
}

BuySharedMoreWaysToBrowseComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    internalBuyLinks: PropTypes.array,
    popularSearchTermClassName: PropTypes.string,
};

export const BuySharedMoreWaysToBrowse = createFragmentContainer(
    BuySharedMoreWaysToBrowseComponent,
    {
        viewer: graphql`
            fragment BuySharedMoreWaysToBrowse_viewer on Viewer {
                ...SharedMobileLinksBlock_viewer
                ...SharedRespLinksBlock_viewer
            }
        `,
        itemSearch: graphql`
            fragment BuySharedMoreWaysToBrowse_itemSearch on ItemSearchQueryConnection {
                ...SharedMobileLinksBlock_itemSearch
                ...SharedRespLinksBlock_itemSearch
            }
        `,
        internalBuyLinks: graphql`
            fragment BuySharedMoreWaysToBrowse_internalBuyLinks on InternalBuyLinkType
            @relay(plural: true) {
                ...SharedMobileLinksBlock_links
                ...SharedRespLinksBlock_links
            }
        `,
    }
);
